/** Частая диагональная штриховка кирпичных стен. */
import { LineHatch, type WallHatchProps } from "./WallHatchGeometry";

export const BrickHatch = ({ outline }: WallHatchProps) => (
	<LineHatch outline={outline} angle={45} spacing={4} />
);
